<template>
  <div>
    <nav-bread :page="{name:'iaoGuides', title: $t('iaoBreadCrumbs.users.title'), sub: $t('iaoBreadCrumbs.users.sub')}"/>
    <el-row class="full-screen">
      <el-input
        v-model="search"
        size="mini"
        class="search"
        :placeholder="$t('user.tableHeader.search')"/>
      <el-table
        :data="extUsers.filter(item => !search || ( item.username.toLowerCase().includes(search.toLowerCase()) || item.group === search) )"
        style="width: 100%"
        height="100vh"
        ref="usersTable"
      >
        <el-table-column
          :label="$t('user.tableHeader.username')"
          prop="username">
        </el-table-column>
        <el-table-column
          :label="$t('user.tableHeader.email')"
          prop="email">
        </el-table-column>

        <el-table-column :label="$t('user.tableHeader.role')">
          <template scope="scope">
            {{getRole(scope.row.role)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('user.tableHeader.group')">
          <template scope="scope">
            {{scope.row.group}}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
  // vuex
  import { mapGetters } from "vuex";

  // store
  import {GET_EXT_USERS} from "../../../../store/actions/users";

  // components
  import UserInfo from './UserInfo';
  import UserInfoSimple from './UserInfoSimple';
  import NavBread from '@/components/navBread/NavBread';
  import {getReferencesApiListApi} from "../../../../api/references";
  import { iaoApi } from '../../../../helpers/iaoApi';

  export default {
    name: 'ExtUsers',
    data() {
      return {
        search: '',
        selectedReference: null,
        references: [],
        roles: this.$t('user.roles'),
      };
    },
    computed: {
      ...mapGetters([
        "extUsers",
        "isAdmin",
      ]),
    },
    methods: {
      getRole(role) {
        const roles = [
          {name: "operator", title: "Оператор КМСС"},
          {name: "operator_3",title: "Оператор"},
          {name: "manager",title: "Пресс-секретарь"},
          {name: "manager_2",title: "Пресс-секретарь вице-губернатора"},
          {name: "manager_3",title: "Менеджер"},
          {name: "admin",title: "Администратор КМСС"},
          {name: "admin_2",title: "Менеджер КМСС"},
          {name: "admin_3",title: "Администратор"},
          {name: "moderator",title: "Модератор"}
        ]
        return roles.find(item => item.name === role).title;
      },
      getReferences() {
        getReferencesApiListApi().then((resp) => {
          console.log(resp)
        })
      }
    },
    components: {
      UserInfo,
      UserInfoSimple,
      NavBread
    },
    mounted() {
      this.getReferences()
      this.$store.dispatch(GET_EXT_USERS, { parent_id: iaoApi(), limit: 500 });
    }
  };
</script>
<style>
 @media screen and (max-width: 480px) {
  .el-table{
      font-size: 10px;
      
  }
  .el-table .cell {
    line-height: unset;
  }
 }
</style>
